import { canUseDom } from './dom';
import { roundToCommonDecimals } from './numbers';

interface RandomNumberCriteria {
    min: number;
    max: number;
    round?: boolean;
}

// TODO: Rename this to `randomFixedNumber()` and allow `round` to
// specify a number of digits after the decimal point.
// Also, update to make the arguments optional.
export function randomValueBetween({ min, max, round = false }: RandomNumberCriteria) {
    const value = Math.random() * (max - min) + min;
    return round ? roundToCommonDecimals(value) : value;
}

export function randomInteger(min = 0, max = 1): number {
    const minCeil = Math.ceil(min);
    const maxFloor = Math.floor(max);

    return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
}

export function randomBoolean(): boolean {
    return Boolean(randomInteger());
}

export function randomId() {
    return canUseDom() && Boolean(window?.crypto?.randomUUID)
        ? window.crypto.randomUUID()
        : `RandomId-${randomValueBetween({ min: 0, max: 1 })}`;
}
